// extracted by mini-css-extract-plugin
module.exports = {"button":"language-picker_button__3KzlY"};